export enum PongoRegistrationStep {
  PONGO_STEP_PHONE = 'PONGO_STEP_PHONE',
  PONGO_STEP_KIOSK_CONFIRMATION = 'PONGO_STEP_KIOSK_CONFIRMATION',
  PONGO_STEP_KIOSK_ACCOUNT_NOT_FOUND = 'PONGO_STEP_KIOSK_ACCOUNT_NOT_FOUND',
  PONGO_STEP_KIOSK_REGISTER = 'PONGO_STEP_KIOSK_REGISTER',
  PONGO_STEP_KIOSK_REGISTER_CONFIRMATION = 'PONGO_STEP_KIOSK_REGISTER_CONFIRMATION',
}
